import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMotorcycle, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import NavigationButtons from './NavigationButtons';
import './NavigationButtons.css';
import './RouteDetails.css';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const RouteDetailsMotorbike = ({ 
  from, 
  to, 
  selectedRoute, 
  setShowBikeRouteOverlay, 
  setSelectedRoute 
}) => {
  return (
    <div className="route-details-overlay">
      <div className="route-details-header">
        <div className="route-details-title">
          <FontAwesomeIcon icon={faMotorcycle} /> {from} to {to}
        </div>
        <button onClick={() => setShowBikeRouteOverlay(false)} className="route-details-close-button">
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
      </div>

      {selectedRoute && (
        <div className="route-details-summary-card">
          <div className="route-details-journey-title">
            Route
          </div>

          <div className="route-details-duration-distance">
            ⏱ <strong>{selectedRoute.duration}</strong> &nbsp; • &nbsp; 📏 {selectedRoute.distance}
          </div>

          <div className="route-details-price">
            🧾 Fare: <strong>{selectedRoute.fare}</strong> &nbsp; • &nbsp; {selectedRoute.noOfPassenger} passenger(s)
          </div>

          <div className="route-details-note">
            Estimated travel time with light traffic. Helmet recommended.
          </div>
        </div>
      )}

      <NavigationButtons
        from={from}
        to={to}
        setSelectedRoute={setSelectedRoute}
        selectedRoute={selectedRoute}
        travelMode="two-wheeler"
      />
    </div>
  );
};

export default RouteDetailsMotorbike; 

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1001,
    backgroundColor: '#EDEDED',
    padding: '1rem',
    overflowY: 'auto'
  },
  adContainer: {
    backgroundColor:'red',
    marginTop: '2rem',
    padding: '0 0.5rem',
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1.2rem'
  },
  title: {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    color: '#1E1E1E',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  closeButton: {
    fontSize: '1.5rem',
    background: 'none',
    border: 'none',
    color: '#333',
    cursor: 'pointer'
  },
  summaryCard: {
    padding: '1rem',
    backgroundColor: '#fff',
    borderRadius: '10px',
    marginBottom: '1.2rem',
    border: '1px solid #eee'
  },
  journeyTitle: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#2A3075',
    marginBottom: '0.5rem'
  },
  durationDistance: {
    fontSize: '1rem',
    color: '#444',
    marginBottom: '0.4rem'
  },
  price: {
    fontSize: '0.95rem',
    color: '#666',
    marginBottom: '0.3rem'
  },
  note: {
    fontSize: '0.85rem',
    color: '#999'
  },
  buttonsContainer: {
    alignItems: 'center',
    marginTop: '10px',
    justifyContent: 'center',
    display: 'flex',
    gap: '1rem'
  },
  button: {
    backgroundColor: '#2A3075',
    color: '#fff',
    padding: '10px 20px',
    borderRadius: '12px',
    fontSize: '1rem',
    fontWeight: 'bold',
    boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',
    minWidth: '90px'
  }
};